import { render, staticRenderFns } from "./BiltyDetails.vue?vue&type=template&id=327db02a&"
import script from "./BiltyDetails.vue?vue&type=script&lang=js&"
export * from "./BiltyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports